var map = {
	"./BlogPosts": "4b99",
	"./BlogPosts.vue": "4b99",
	"./Cards": "b2be",
	"./Cards.vue": "b2be",
	"./FigmaPlugin": "c762",
	"./FigmaPlugin.vue": "c762",
	"./Footer": "2564",
	"./Footer.vue": "2564",
	"./Header": "edba",
	"./Header.vue": "edba",
	"./HowItWorks": "8e57",
	"./HowItWorks.vue": "8e57",
	"./Main": "2b8b",
	"./Main.vue": "2b8b",
	"./MarketingShell": "ee86",
	"./MarketingShell.vue": "ee86",
	"./Overview": "5999",
	"./Overview.vue": "5999",
	"./Pricing": "16cf",
	"./Pricing.vue": "16cf",
	"./ProductHunt": "a43e",
	"./ProductHunt.vue": "a43e",
	"./SeoOverview": "94f1",
	"./SeoOverview.vue": "94f1",
	"./Testimonials": "cfbd",
	"./Testimonials.vue": "cfbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f68";